/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { Fraction } from './Fraction';
const AssignmentPointsGradingSettingsParser = 
/* #__PURE__ */ parsers.object([
    ['scale', /* #__PURE__ */ parsers.exactly('points')],
    ['points', Fraction],
]);
export class AssignmentPointsGradingSettings extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssignmentPointsGradingSettingsParser.decode(input).map(res => new AssignmentPointsGradingSettings(res));
    }
    static unsafeDecode(input) {
        return AssignmentPointsGradingSettings.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentPointsGradingSettingsParser.encode(data);
    }
    static schema() {
        return AssignmentPointsGradingSettingsParser.schema();
    }
}
